import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'loading',
  templateUrl: './loading.component.html'
})

export class LoadingComponent implements OnInit {
 ngOnInit(): void {
    
  }
}
